import styled from "styled-components";

export const TestimonialAuthor = styled.div.attrs({
  className: "text-subtitle uppercase mt-m"
})`
  grid-area: author;
`;